/**
 * author: Soumya Shreyas
 */
import moment from "moment";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Badge, Form, Table, Button, Dropdown } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { withTranslation } from "react-i18next";
import {
  BiSearch,
  BiSort,
  BiDotsHorizontalRounded,
  BiPlus
} from "react-icons/bi";
import { Link } from "react-router-dom";
import { FcFinePrint } from "react-icons/fc";

import { CompanyContext, RegulationContext } from "../../../App";
import Pagination from "../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LIST_DEF_SORT,
  RISKSTATUS,
  SORT_ORDER_DESC, STATUS, TASK_PRIORITY, TASK_STATUS
} from "../../../core/constants/common";
import CompanyDashboardService from "../../../core/service/CompanyDashboardService";
import TruncatedText from "../../../core/utilities/TruncatedText";
import nodataimg from "../../../images/nodatafound.png";
import TaskModal from "../TaskModal/TaskModal";
import "./SupplierTasksList.scss";
import { CgSortAz } from "react-icons/cg";
import Multiselect from 'multiselect-react-dropdown';

function SupplierTasksList({ t, detailedView = true, externalFilter }) {
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [searchKey, setSearchKey] = useState("");
  const [tasks, setTasks] = useState([]);
  const [modalDisplay, setModalDisplay] = useState(false);
  const [taskId, setTaskId] = useState(0);
  const [modalData, setModalData] = useState(null);

  const { glbRegulation } = useContext(RegulationContext);
  const { glbCompany } = useContext(CompanyContext);

  const glbRegulationCode = glbRegulation?.code ?? "";
  const glbCompanyId = glbCompany?.companyId ?? "";
  const authorityData = JSON.parse(localStorage.getItem("authority"));
  const loggedInUserCompanyId = authorityData.profile.company.id;
  const [status, setStatusKey] = useState("");
  const [priority, setPriority] = useState("");
  const [assigneeId, setAssignee] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [companyName, setCompanyName] = useState([]);
  const [assigneeList, setAssigneeList] = useState([]);
  const [companyNameList, setCompanyNameList] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedAssigneeValues, setSelectedAssigneeValues] = useState([]);
  const [selectedCompanyValues, setSelectedCompanyValues] = useState([]);
  const [selectedOptionsAssignee, setSelectedOptionsAssignee] = useState([]);
  const [selectedOptionsCompany, setSelectedOptionsCompany] = useState([]);
  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState([]);
  const [selectedOptionsPriority, setSelectedOptionsPriority] = useState([]);
  const [Key, setRefreshKey] = useState(0);


  const listTasks = useCallback((
    pageNumber,
    itemsPerPageVal,
    searchKeyWord,
    sortFieldName,
    status,
    priority,
    assigneeId,
    ownerId
  ) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    let perPage;
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    } else {
      perPage = itemsPerPage;
    }
    var sort = sortFieldName + "," + order;
    CompanyDashboardService.listTasks(
      pageNumber,
      perPage,
      glbRegulationCode,
      glbCompanyId,
      searchKeyWord,
      sort,
      status,
      priority,
      assigneeId,
      ownerId,
      externalFilter
    ).then((response) => {
      var totalPages = parseFloat(response.headers["x-total-count"]);
      setItemTotalCount(totalPages);
      setTasks([...response.data]);
      for (let index = 0; index < response.data.length; index++) {
        const element = response.data[index];
        companyNameList.push({
          name: element.ownerCompany.legalName,
          value: element.ownerCompany.id
        });
        assigneeList.push({
          name: element.assignedUsers[0].name,
          value: element.assignedUsers[0].id
        });
      }
      const uniqueArrayAssignee = assigneeList.filter(
        (item, index) => index === assigneeList.findIndex(obj => JSON.stringify(obj) === JSON.stringify(item))
      );
      setAssigneeList(uniqueArrayAssignee);
      const uniqueArrayCompany = companyNameList.filter(
        (item, index) => index === companyNameList.findIndex(obj => JSON.stringify(obj) === JSON.stringify(item))
      );
      setCompanyNameList(uniqueArrayCompany);
    }).catch((error) => {
    });
  }, [itemsPerPage, order, glbRegulationCode, glbCompanyId, externalFilter]);

  useEffect(() => {
    listTasks(0, itemsPerPage, searchKey, sortField, status, priority, selectedAssigneeValues, selectedCompanyValues);
  }, [listTasks, glbRegulationCode, glbCompanyId, searchKey, sortField, itemsPerPage, externalFilter]);


  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
  };

  const handleSearch = (e) => {
    const key = e.target.value;
    setSearchKey(key);
  };

  const handleTaskSave = () => {
    setModalDisplay(false);
    listTasks(0, itemsPerPage, searchKey, sortField, status, priority, selectedAssigneeValues, selectedCompanyValues);
  };

  const handleNewTaskClick = () => {
    setTaskId(0);
    setModalData(null);
    setModalDisplay(true);
  };

  const handleActionClick = (task, action) => {
    setTaskId(task.id);
    setModalData({ ...task, openedFor: action });
    setModalDisplay(true);
  };

  const filterApply = () => {
    listTasks(0, itemsPerPage, searchKey, sortField, status, priority, selectedAssigneeValues, selectedCompanyValues);
  }

  const filterReset = () => {
    setStatusKey([]);
    setPriority([]);
    setSelectedAssigneeValues([]);
    setSelectedCompanyValues([]);
    setSelectedOptionsAssignee([]);
    setSelectedOptionsCompany([]);
    setSelectedOptionsPriority([]);
    setSelectedOptionsStatus([]);
    setRefreshKey((prevKey) => prevKey + 1);
    listTasks(0, itemsPerPage, searchKey, sortField);
  }

  const handleSelectAssignee = (selectedList) => {
    setSelectedOptionsAssignee(selectedList);
    setSelectedAssigneeValues(selectedList.map((item) => item.value));
  };
  const handleRemoveAssignee = (selectedList) => {
    setSelectedOptionsAssignee(selectedList);
    setSelectedAssigneeValues(selectedList.map((item) => item.value));
  };
  const handleSelectCompany = (selectedList) => {
    setSelectedOptionsCompany(selectedList);
    setSelectedCompanyValues(selectedList.map((item) => item.value));
  };
  const handleRemoveCompany = (selectedList) => {
    setSelectedOptionsCompany(selectedList);
    setSelectedCompanyValues(selectedList.map((item) => item.value));
  };
  const handleSelectStatus = (selectedList) => {
    setSelectedOptionsStatus(selectedList);
    setStatusKey(selectedList.map((item) => item.value));
  };
  const handleRemoveStatus = (selectedList) => {
    setSelectedOptionsStatus(selectedList);
    setStatusKey(selectedList.map((item) => item.value));
  };
  const handleSelectPriority = (selectedList) => {
    setSelectedOptionsPriority(selectedList);
    setPriority(selectedList.map((item) => item.value));
  };
  const handleRemovePriority = (selectedList) => {
    setSelectedOptionsPriority(selectedList);
    setPriority(selectedList.map((item) => item.value));
  };

  return (
    <>
      <div className="FormsList">
        {detailedView && <div className="List_header">
          <h5 className="MH">
            {t("Tasks.label")}
          </h5>
          <div className="List_sorts_menu">
            <ul>
              <li>
                <Button variant="primary" className="px-3" onClick={() => handleNewTaskClick()}>
                  <BiPlus />  {t("New.label")}
                </Button>
              </li>
            </ul>
          </div>
        </div>
        }
        <div className="dropdown">
          <Link to="#" ><Dropdown className="filter_design" autoClose={false}>
            <Dropdown.Toggle className="btn btn-secondary">
              <CgSortAz />{t("Filter.label")}
            </Dropdown.Toggle>
            <Dropdown.Menu className="filter-dropdown-menu">
              <div className="px-2">
                <div className="pb-2">
                  <label>Status</label>
                  <Multiselect
                    options={TASK_STATUS}
                    selectedValues={selectedOptionsStatus}
                    onSelect={handleSelectStatus}
                    onRemove={handleRemoveStatus}
                    displayValue="label"
                    key={Key}
                  />
                </div>
                <div className="pb-2">
                  <label>Priority</label>
                  <Multiselect
                    options={TASK_PRIORITY}
                    selectedValues={selectedOptionsPriority}
                    onSelect={handleSelectPriority}
                    onRemove={handleRemovePriority}
                    displayValue="label"
                    key={Key}
                  />
                </div>
                <div className="pb-2">
                  <label>Company Name</label>
                  <Multiselect
                    options={companyNameList}
                    selectedValues={selectedOptionsCompany}
                    onSelect={handleSelectCompany}
                    onRemove={handleRemoveCompany}
                    displayValue="name"
                    key={Key}
                  />
                </div>
                <div className="pb-2">
                  <label>Assignee</label>
                  <Multiselect
                    options={assigneeList}
                    selectedValues={selectedOptionsAssignee}
                    onSelect={handleSelectAssignee}
                    onRemove={handleRemoveAssignee}
                    displayValue="name"
                    key={Key}
                  />
                </div>
                <div className="pb-2 text-center">
                  <button className="btn btn-primary" onClick={() => filterApply()}>Apply</button>
                  <button className="btn btn-secondary ms-2" onClick={() => filterReset()}>Reset</button>
                </div>
              </div>
            </Dropdown.Menu>
          </Dropdown>
          </Link>
        </div>



        <div className="List_Table_01">
          {detailedView && <div className="List_table-card01_head">
            <div className="List_table-card_Search_01">
              <div className="List_table-card_Search_Box">
                <Form>
                  <input
                    type="text"
                    className="form-control"
                    value={searchKey}
                    onChange={handleSearch}
                    placeholder="Search by Tasks"
                  />
                  <Link to="#" className="Search_iocnBox">
                    <BiSearch />
                  </Link>
                </Form>
              </div>
            </div>
          </div>
          }
          <div className={detailedView ? 'card List_table-card01' : 'List_table-card01'}>
            <Table responsive="sm">
              <thead>
                <tr>
                  {/* <th className="th_check">
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th> */}
                  <th className="task-title-col">{t("Title.label")}</th>

                  <th>
                    <Link to="#" onClick={() => handleSort("dueDate")}>
                      {t("DueDate.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("status")}>
                      {t("Status.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>{t("Priority.label")} </th>
                  {detailedView && <th> {t("Assignee.label")}</th>}
                  {!glbCompanyId && <th>   {t("CompanyName.label")}</th>}
                  {detailedView && <th></th>}
                </tr>
              </thead>
              <tbody>
                {tasks?.length > 0 ? (
                  tasks?.map((item, index) => (
                    <tr key={item.id}>
                      {/* <td className="checkbox">
                        {" "}
                        <Form.Check
                          inline
                          name="group1"
                          type="checkbox"
                          id="inline-checkbox-1"
                        />
                      </td> */}
                      <td className="task-title-col"><TruncatedText text={item.title}></TruncatedText></td>

                      <td> {item.dueDate ? moment(item.dueDate).format("MMM DD, YYYY") : ""}</td>
                      <td>
                        {(() => {
                          switch (item.status) {
                            case "NEW":
                              return (
                                <Badge bg="badge-New">
                                  {STATUS[item.status]}
                                </Badge>
                              );
                            case "IN_PROGRESS":
                              return (
                                <Badge bg="badge-Inprogress">
                                  {STATUS[item.status]}
                                </Badge>
                              );
                            case "CLOSED":
                              return (
                                <Badge bg="badge-Closed">
                                  {STATUS[item.status]}
                                </Badge>
                              );
                            default:
                              return " ";
                          }
                        })()}
                      </td>
                      <td>
                        {(() => {
                          switch (item.priority) {
                            case "LOW":
                              return (
                                <Badge bg="badge-Low">{t("Low.label")}</Badge>
                              );
                            case "MEDIUM":
                              return (
                                <Badge bg="badge-Medium">{t("Medium.label")}</Badge>
                              );
                            case "HIGH":
                              return (
                                <Badge bg="badge-High">{t("High.label")}</Badge>
                              );
                            case "CRITICAL":
                              return (
                                <Badge bg="badge-Critical">{t("Critical.label")}</Badge>
                              );
                            default:
                              return " ";
                          }
                        })()}
                      </td>
                      {detailedView && <td>{
                        loggedInUserCompanyId !== item.ownerCompany?.id && item.defaultAssignee?.id > 0
                          ? item.defaultAssignee?.name
                          : item.assignedUsers?.map((user, index) => {
                            return (user.name || '') + (index === item.assignedUsers.length - 1 ? '' : ', ')
                          })
                      }</td>}
                      {!glbCompanyId && <td> {item?.ownerCompany?.legalName}</td>}
                      {detailedView && <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="blank_outline"
                            id="task-list-dropdown">
                            <BiDotsHorizontalRounded />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {
                              item.status !== "CLOSED"
                                ?
                                <Dropdown.Item onClick={() => handleActionClick(item, "EDIT")}>
                                  {t("Edit.label")}
                                </Dropdown.Item>
                                : <></>
                            }
                            <Dropdown.Item onClick={() => handleActionClick(item, "VIEW")}>
                              {t("View.label")}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {(detailedView || itemsTotalCount > 10) && <div className="p-2 List_footer_count">
              <Pagination
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  listTasks(pageNum, perPage, searchKey, sortField, status, priority, selectedAssigneeValues, selectedCompanyValues);
                }}
              />
            </div>}
          </div>
        </div>
      </div>
      {
        modalDisplay
          ?
          <TaskModal
            showModal={modalDisplay}
            id={taskId}
            modalData={modalData}
            onSaveCallBack={() => handleTaskSave()}
            onCloseCallback={() => { setModalDisplay(false); }}>
          </TaskModal>
          : <></>
      }
    </>
  );
}
SupplierTasksList.propTypes = {};

export default withTranslation()(SupplierTasksList);
